import { render, staticRenderFns } from "./correctDetail.vue?vue&type=template&id=5609dcfa&scoped=true&"
import script from "./correctDetail.vue?vue&type=script&lang=js&"
export * from "./correctDetail.vue?vue&type=script&lang=js&"
import style0 from "./correctDetail.vue?vue&type=style&index=0&id=5609dcfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609dcfa",
  null
  
)

export default component.exports